import { connect } from 'react-redux';

// Components
import DemoScenarios from './component';

// Selectors
import {
  getScenarios,
  getSelectedScenario,
  getComparingScenarios,
  getSelectedComparingScenario,
} from 'components/atmo-demo/selectors';

// Actions
import { setScenario, setComparingScenario, setViewport } from 'components/atmo-demo/actions';


const mapStateToProps = state => ({
  scenarios: getScenarios(state),
  selectedScenario: getSelectedScenario(state),
  comparingScenarios: getComparingScenarios(state),
  selectedComparingScenario: getSelectedComparingScenario(state),
});

const mapDispatchToProps = dispatch => ({
  setScenario: scenario => dispatch(setScenario(scenario)),
  setComparingScenario: scenario => dispatch(setComparingScenario(scenario)),
  setViewport: viewport => dispatch(setViewport(viewport))
});


export default connect(mapStateToProps, mapDispatchToProps)(DemoScenarios);



// WEBPACK FOOTER //
// ./src/components/atmo-demo/components/scenario-info/index.js